﻿import * as $helpers from './_helpers'
import { loadBlogPostModal, saveDontShowAgain } from './blog.shared'

export interface IInitOptions {
    pageName: string
    pagePrefix: string
    pageId: number
    postId: number
}

var options: IInitOptions

export const init = ($options: IInitOptions): void => {
    options = $options

    $helpers.partialPageInit($('.' + options.pageName))

    elem('__btn--readmore').click(() => {
        loadBlogPostModal(options.postId)
        if (dontShowAgainChecked()) saveDontShowAgain(options.postId, () => {})
        closePopup()
    })

    elem('__btn--close').click(() => {
        if (dontShowAgainChecked()) saveDontShowAgain(options.postId, () => {})
        closePopup()
    })
}

export const load = (page: number): void => {
    setTimeout(() => {
        const div: JQuery = $('<div />')
        div.load(`/blog/blogpostpopup?page=${page}`)
        $('body').append(div)
    }, 3000)
}

const elem = (sel: string): JQuery => {
    return $(`.${options.pageName} .${options.pagePrefix}${sel}`)
}

const dontShowAgainChecked = (): boolean => {
    return $(`.${options.pageName} .bcfla-checkboxlist .bcfla-checked`).length > 0
}

const closePopup = () => {
    $('.' + options.pageName).fadeOut()
}
